export default __webpack_public_path__ + "static/media/logo.36a49d13.svg";